import { action, PayloadAction } from 'typesafe-actions';
import { TempDataState, tempDataActions } from './tempData.types';

export const saveTempData = (data: TempDataState): PayloadAction<string, TempDataState> =>
	action(tempDataActions.saveTempData, data);
